<div class="card max-w-2xl mx-auto">
  <!-- Header -->
  <div class="px-6 py-4 border-b border-gray-200" *ngIf="querystringreg">
    <h3 class="text-xl font-semibold">
      Create User
    </h3>
  </div>

  <!-- Card Body -->
  <div class="p-6">
    <form [formGroup]="registerForm" (ngSubmit)="register()" class="space-y-6">
      <!-- Name Fields Row -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="space-y-2">
          <label for="input-first-name" class="block text-sm font-medium text-gray-900 dark:text-white">
            First Name
          </label>
          <kendo-textbox id="input-first-name" class="w-full " formControlName="firstname" placeholder="First name"
            [attr.aria-invalid]="f['firstname'].invalid && f['firstname'].touched ? true : null">
          </kendo-textbox>
          <span *ngIf="f['firstname']?.errors?.required && f['firstname'].touched"
            class="text-sm text-red-600 dark:text-red-400">
            First name is required
          </span>
        </div>
        <div class="space-y-2">
          <label for="input-last-name" class="block text-sm font-medium text-gray-900 dark:text-white">
            Last Name
          </label>
          <kendo-textbox id="input-last-name" class="w-full " formControlName="lastname" placeholder="Last name"
            [attr.aria-invalid]="f['lastname'].invalid && f['lastname'].touched ? true : null">
          </kendo-textbox>
          <span *ngIf="f['lastname']?.errors?.required && f['lastname'].touched"
            class="text-sm text-red-600 dark:text-red-400">
            Last name is required
          </span>
        </div>
      </div>
      <!-- Contact Information Row -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="space-y-2">
          <label for="input-phone" class="block text-sm font-medium text-gray-900 dark:text-white">
            Mobile Phone
          </label>
          <kendo-maskedtextbox id="input-phone" class="w-full " formControlName="phonenumber"
            [mask]="phoneMask" [promptPlaceholder]="' '"
            [attr.aria-invalid]="f['phonenumber'].invalid && f['phonenumber'].touched ? true : null">
          </kendo-maskedtextbox>
          <span *ngIf="f['phonenumber']?.errors?.required && f['phonenumber'].touched"
            class="text-[10px] text-red-600 dark:text-red-400">
           <br/> Mobile number is required
          </span>
        </div>
        <div class="space-y-2">
          <label for="input-email" class="block text-sm font-medium text-gray-900 dark:text-white">
            Email Address
          </label>
          <kendo-textbox id="input-email" class="w-full " formControlName="email" placeholder="Email address"
            [attr.aria-invalid]="f['email'].invalid && f['email'].touched ? true : null">
          </kendo-textbox>
          <span *ngIf="f['email']?.errors?.required && f['email'].touched"
            class="text-sm text-red-600 dark:text-red-400">
            Email address is required
          </span>
          <span *ngIf="f['email']?.hasError('pattern') && f['email'].touched"
            class="text-sm text-red-600 dark:text-red-400">
            Invalid email address format
          </span>
        </div>
      </div>

      <!-- Username Field -->
      <div class="space-y-2">
        <label for="input-username" class="block text-sm font-medium text-gray-900 dark:text-white">
          Username
        </label>
        <kendo-textbox id="input-username" class="w-full " [readonly]="false" formControlName="username"
          placeholder="Username (auto-generated, editable)"
          [attr.aria-invalid]="f['username']?.invalid && f['username']?.touched ? true : null">
        </kendo-textbox>
        <span *ngIf="f['username']?.errors?.required && f['username']?.touched"
          class="text-sm text-red-600 dark:text-red-400">
          Username is required
        </span>
      </div>

      <!-- Roles Selection -->
      <div class="space-y-2">
        <label for="input-roles" class="block text-sm font-medium text-gray-900 dark:text-white">
          Select Roles
        </label>
        <kendo-multiselect id="input-roles" style="color:#000" class="w-full" formControlName="roles" [data]="roles$"
          [textField]="'name'" [valueField]="'id'" placeholder="Select roles..." [valuePrimitive]="true"
          [value]="mySelectionroleLinks" [filterable]="true">
        </kendo-multiselect>
        <span *ngIf="f['roles']?.hasError('pattern') && f['roles'].touched"
          class="text-sm text-red-600 dark:text-red-400">
          Invalid role pattern
        </span>
        <span *ngIf="f['roles']?.errors?.required && f['roles'].touched" class="text-sm text-red-600 dark:text-red-400">
          Role selection is required
        </span>
      </div>
      <!-- Branch List (Conditional - Shows for Branch Manager or Branch Access Non Manager, hides for Rep) -->
      <div *ngIf="showBranchSelection" class="space-y-2">
        <label for="input-branchlist" class="block text-sm font-medium text-gray-900 dark:text-white">
       Choose branches to link the user to:
        </label>
        <kendo-multiselect #multiselect id="input-branchlist" class="w-full k-multiselect"
          (valueChange)="onSelectionChange($event)" formControlName="branchlist" [data]="branchrolelist$"
          [value]="mySelectionBranchLinks"
          [filterable]="true" [kendoDropDownFilter]="filterSettings" placeholder="Select branches...">
        </kendo-multiselect>

        <div *ngIf="showBranchAccessNonManager" class="mt-3">
          <div class="flex items-center">
            <input style="height:17px;"
              type="checkbox"
              id="cbReceiveBranchRepEmails"
              formControlName="cbReceiveBranchRepEmails"
              kendoCheckBox
              class="form-checkbox h-4 w-4 text-blue-550 rounded focus:ring-blue-500 dark:focus:ring-blue-550 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-550" />
            <label for="cbReceiveBranchRepEmails" class="ml-2 text-sm font-medium text-gray-900 dark:text-white">
              Receive all Emails for Branch Reps:
            </label>
          </div>
          <div class="ml-6 text-[10px] text-gray-500 dark:text-gray-400">
            For update or new users, check this every time to receive all emails, or uncheck to not receive them.
          </div>
        </div>

      </div>

      <!-- Product Selection (Conditional - Only for Branch Manager, not Rep) -->
      <div *ngIf="showProductSelection" class="space-y-4 border-t pt-4">
        <h4 class="text-sm font-semibold text-gray-900 dark:text-white">Choose a products user can approve: </h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="flex flex-col">
            <div class="rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 dark:bg-gray-800 p-3">
              <kendo-grid [data]="productlist$"  formControlName="products" [pageable]="false" [scrollable]="false"
               [selectable]="{ enabled: true, mode: 'multiple', checkboxOnly: true }" kendoGridSelectBy="productTypeId" [(selectedKeys)]="mySelection"
                (selectedKeysChange)="onSelectedKeysChangeProducts($event)">
                <kendo-grid-checkbox-column [width]="40"></kendo-grid-checkbox-column>
                <kendo-grid-column field="productTypeDesc2" title="Product Type"></kendo-grid-column>
              </kendo-grid>
            </div>
          </div>
          <!-- Products User Can Access 
          <div class="space-y-2">
            <label for="input-products" class="block text-sm font-medium text-gray-900 dark:text-white">
              Products User Can Access
            </label>
            <kendo-multiselect 
              id="input-products" 
              class="w-full k-multiselect" 
              formControlName="products"
              [data]="productlist$" 
              [textField]="'name'" 
              [valueField]="'id'" 
              [value]="mySelectionProducts"
              placeholder="Select products...">
            </kendo-multiselect>
          </div>
        -->
          <!-- Products User Can Approve -->
                  
        <!-- Receive All Emails Checkbox -->
        <div class="mt-3">
          <div class="flex items-center">
            <input style="height:17px;"
              type="checkbox"
              id="receiveAllEmails"
              formControlName="approveProducts"
              kendoCheckBox
              class="form-checkbox h-4 w-4 text-blue-550 rounded focus:ring-blue-500 dark:focus:ring-blue-550 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-550" />
            <label for="receiveAllEmails" class="ml-2 text-sm font-medium text-gray-900 dark:text-white">
              Receive all Emails for Branch Reps
            </label>
          </div>
          <div class="ml-6 text-[10px] text-gray-500 dark:text-gray-400">
            For update or new users, check this every time to receive all emails, or uncheck to not receive them.
          </div>
        </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="flex justify-end pt-4 border-t border-gray-200 dark:border-gray-700">
        <button kendoButton [disabled]="submitted || !registerForm.valid"
          class="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 dark:disabled:bg-gray-600 text-white px-6 py-2 rounded-md font-medium transition-colors">
          {{ buttontext }}
        </button>
      </div>
    </form>
  </div>
</div>